app.service("ProgressNoteAPI", [
    "$http",
    "ENV",
    "Session",
    function ($http, ENV, Session) {
       var service = {
          isProcessing: false,
          getProgressNotes: function (patientId) {
             return $http({
                method: "GET",
                url: ENV.API + `/api/progress-note/${patientId}`,
                headers: {
                   Authorization: "Bearer " + Session.token,
                   "X-PRACTICE-ID": `${Session.practice.id}`,
                },
             });
          },
          // addAutoTaskProgressNote=true&addAutoTaskWaitlist=true
           createProgressNote: function (progressNote, option) {
            let parameters = '';
            if(option && option.addAutoTaskProgressNote === 'true'){
               parameters = '&addAutoTaskProgressNote=true';
            }else if(option && option.addAutoTaskProgressNote === 'false'){
               parameters = '&addAutoTaskProgressNote=false';
            }

            if(option && option.addAutoTaskWaitlist === 'true'){
               parameters = parameters + '&addAutoTaskWaitlist=true';
            }else if(option && option.addAutoTaskWaitlist === 'false'){
               parameters = parameters + '&addAutoTaskWaitlist=false';
            }

            if(option && option.sendHL7ToGP === 'true'){
                parameters = parameters + '&sendHL7ToGP=true';
            }else if (option && option.sendHL7ToGP === 'false'){
                parameters = parameters + '&sendHL7ToGP=false';
            }

            return $http({
               method: "POST",
               url: ENV.API + `/api/progress-note?sendHL7=true${parameters}`,
               headers: {
                  Authorization: "Bearer " + Session.token,
                  "X-PRACTICE-ID": `${Session.practice.id}`,
               },
               data: progressNote
            });
          },
          deleteProgressNote: function (patientId, noteId) {
            return $http({
               method: "DELETE",
               url: ENV.API + `/api/progress-note/${patientId}/${noteId}`,
               headers: {
                  Authorization: "Bearer " + Session.token,
                  "X-PRACTICE-ID": `${Session.practice.id}`,
               },
            });
          },
          restoreProgressNote: function (patientId, noteId) {
            return $http({
               method: "PUT",
               url: ENV.API + `/api/progress-note/${patientId}/${noteId}`,
               headers: {
                  Authorization: "Bearer " + Session.token,
                  "X-PRACTICE-ID": `${Session.practice.id}`,
               },
            });
          },
          updateVisibility: function (patientId, noteId,level) {
            return $http({
               method: "PUT",
               url: ENV.API + `/api/progress-note/${patientId}/${noteId}/security?securityLevel=${level}`,
               headers: {
                  Authorization: "Bearer " + Session.token,
                  "X-PRACTICE-ID": `${Session.practice.id}`,
               },
            });
          },
          // No body: the signing doctor and timestamp are taken server-side from the bearer token
          // and the server clock.
          signOffStandingOrder: function (patientId, noteId) {
            return $http({
               method: "PATCH",
               url: ENV.API + `/api/progress-note/${patientId}/${noteId}/sign-off`,
               headers: {
                  Authorization: "Bearer " + Session.token,
                  "X-PRACTICE-ID": `${Session.practice.id}`,
               },
            });
          },
       }
        return service;
    }]);